import { useCallback, useMemo } from 'react';
import { useCookie } from '@trinity/chat-components/hooks';
import { ChatWelcomeScreenContext } from './Context';
import { useGroupFeatures } from '../Chat';

const cookie = {
  name: 'msl-copilot:chat-welcome-screen-visibility',
  hidden: 'hidden',
};

type Props = {
  children: React.ReactNode;
};

export const ChatWelcomeScreenContainer = (props: Props) => {
  const features = useGroupFeatures();
  const enabled = features.chatWelcomeScreen;

  const [value, setCookie] = useCookie(cookie.name);

  const visible = useMemo(() => {
    return value !== cookie.hidden && enabled;
  }, [
    enabled,
    value,
  ]);

  const dismiss = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: cookie.hidden,
    });
  }, [setCookie]);

  const reset = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: '',
    });
  }, [setCookie]);

  const ctx = {
    dismiss,
    enabled,
    reset,
    visible,
  };

  return (
    <ChatWelcomeScreenContext.Provider value={ctx}>
      {props.children}
    </ChatWelcomeScreenContext.Provider>
  );
};

ChatWelcomeScreenContainer.displayName = 'ChatWelcomeScreen.Container';